const files = new Map();
const urls = new Map();

let seq = 0;
export const newFileKey = () => `f-${Date.now().toString(36)}-${(seq += 1)}`;

export const putFile = (file) => {
    const key = newFileKey();
    files.set(key, file);
    return key;
};

export const hasFile = (key) => Boolean(key) && files.has(key);

export const fileUrl = (key) => {
    if (!hasFile(key)) return null;
    if (!urls.has(key)) urls.set(key, URL.createObjectURL(files.get(key)));
    return urls.get(key);
};

export const openFile = (key) => {
    const url = fileUrl(key);
    if (!url) return false;
    window.open(url, '_blank', 'noopener');
    return true;
};

export const downloadFile = (key, fileName) => {
    const url = fileUrl(key);
    if (!url) return false;
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName || 'document';
    a.click();
    return true;
};

export const dropFile = (key) => {
    const url = urls.get(key);
    if (url) URL.revokeObjectURL(url);
    urls.delete(key);
    files.delete(key);
};

export const fmtSize = (bytes) => {
    const b = Number(bytes) || 0;
    if (b <= 0) return '—';
    if (b < 1024) return `${b} B`;
    if (b < 1024 * 1024) return `${Math.round(b / 1024)} KB`;
    return `${(b / (1024 * 1024)).toFixed(1)} MB`;
};

export const fileKind = (name = '') => {
    const ext = String(name).split('.').pop().toLowerCase();
    if (['pdf'].includes(ext)) return { label: 'PDF', color: '#DC2626', bg: '#FEF2F2' };
    if (['jpg', 'jpeg', 'png', 'webp', 'gif'].includes(ext)) return { label: 'IMG', color: '#0EA5E9', bg: '#E0F2FE' };
    if (['doc', 'docx'].includes(ext)) return { label: 'DOC', color: '#2563EB', bg: '#EFF6FF' };
    if (['xls', 'xlsx', 'csv'].includes(ext)) return { label: 'XLS', color: '#16A34A', bg: '#DCFCE7' };
    return { label: (ext || 'FILE').slice(0, 4).toUpperCase(), color: '#64748B', bg: '#F1F5F9' };
};
